module.exports = __webpack_public_path__ + "img/wifi.eb47ac19.png";